import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

/** JWT / Identity Server issuers use www.*; same-origin storage and tokens must match that host. */
(() => {
  const apexToWww: Record<string, string> = {
    'bocatennisladder.com': 'https://www.bocatennisladder.com',
    'bocapickleballladder.com': 'https://www.bocapickleballladder.com',
  };
  const wwwOrigin = apexToWww[window.location.hostname.toLowerCase()];
  if (wwwOrigin) {
    window.location.replace(
      wwwOrigin + window.location.pathname + window.location.search + window.location.hash
    );
  }
})();

export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

const providers = [
  { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] }
];

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic(providers).bootstrapModule(AppModule)
  .catch(err => console.log(err));
